import { to_array } from "./to_array"

export const first = any => to_array(any)[0]
